module.exports = __webpack_public_path__ + "static/media/app4.49efd658.jpeg";